import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FLOW_TYPE } from '../../../framework/App/AppConstants';
import ProfilePictureDisplay, { THEME } from '../../../shared-components/ProfilePicture/ProfilePictureDisplay';
import './UserInfoCard.less';

export class UserInfoCard extends Component {
    static propTypes = {
        user: PropTypes.shape({
            firstName: PropTypes.string.isRequired,
            lastName: PropTypes.string.isRequired
        }).isRequired,
        address: PropTypes.shape({
            addressLine1: PropTypes.string.isRequired,
            addressLine2: PropTypes.string,
            city: PropTypes.string.isRequired,
            state: PropTypes.string.isRequired,
            postalCode: PropTypes.string.isRequired
        }).isRequired,
        flow: PropTypes.string,
        showProfilePicture: PropTypes.bool,
        onUpdate: PropTypes.func.isRequired
    };

    handleOnClick = event => {
        event.preventDefault();
        return this.props.onUpdate();
    };

    render() {
        const { user, address, flow, showProfilePicture } = this.props;
        const { firstName, lastName } = user;
        const { addressLine1, addressLine2, city, state, postalCode } = address;

        const addressCard = (
            <div className="address">
                <div>{addressLine1}</div>
                {addressLine1 && <div>{addressLine2}</div>}
                <div>{city}, {state}, {postalCode}</div>
            </div>
        );

        const showProfilePicOrInitials = () => {
            return flow === FLOW_TYPE.VENICE || showProfilePicture;
        };

        let userInfoCardClasses = 'UserInfoCard';
        if (showProfilePicOrInitials()) {
            userInfoCardClasses += ' UserInfoCard--hasPicture';
        }

        return (
            <div id="billing-address-user-info-card" className={userInfoCardClasses}>
                {showProfilePicOrInitials() && <ProfilePictureDisplay theme={THEME.LIGHT_BLUE} />}
                <div className="user-info-card">
                    <div className="address-block">
                        <div className="name">{firstName} {lastName}</div>
                        {addressCard}
                    </div>
                    <a href="#!"
                        data-automation-id="update-user-info"
                        id="update-user-info"
                        onClick={this.handleOnClick}
                    >Update</a>
                </div>
            </div>
        );
    }
}

export default UserInfoCard;
